import { adminRoutes, curatorRoutes } from "@src/config/appRoutes";
import { useAuthCurator } from "@src/hooks/useAuth";
import { useAppSelector } from "@src/redux/hooks";

export const useAuthorizedRoutes = () => {
  const role = useAppSelector((state) => state.auth.role);
  const curator = useAuthCurator();

  const vinylListEnabled = curator?.vinylListEnabled ?? false;
  const canAccessArticles =
    role?.type === "admin" ||
    role?.type === "manager" ||
    Boolean(curator?.articleEditor);

  const routes =
    role?.type === "admin"
      ? adminRoutes
      : role?.type === "manager"
        ? adminRoutes.filter((route) => !route.adminOnly)
        : curator?.isSubcurator
          ? curatorRoutes.filter(
              (route) =>
                route.name !== "guest-curator" &&
                (route.name !== "articles" || canAccessArticles) &&
                (route.name !== "vinyl-list" || vinylListEnabled)
            )
          : curatorRoutes.filter(
              (route) =>
                (route.name !== "articles" || canAccessArticles) &&
                (route.name !== "vinyl-list" || vinylListEnabled)
            );

  return routes;
};
